(() => {
  'use strict';
  if (window.__SQ_EXPANDED_X_CART_BLOCK_V1__) return;
  window.__SQ_EXPANDED_X_CART_BLOCK_V1__ = true;

  const MODAL = '[data-lcs-favorite-expanded]';
  const ROOT = '[data-lcs-expanded-controller],[data-lcs-favorites-page]';
  const CLOSE_X = '[data-lcs-expanded-close],.lcs-favorite-expanded__close,[data-premium-expanded-close]';
  const CART_OPENERS = [
    '[data-cart-drawer-toggle]',
    '[data-cart-drawer-open]',
    '[aria-controls="CartDrawer"]',
    '[aria-controls="cart-drawer"]',
    '#cart-icon-bubble'
  ].join(',');

  let guardUntil = 0;

  const closeTarget = (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const close = target?.closest(CLOSE_X);
    return close?.closest(MODAL) ? close : null;
  };

  const arm = (ms = 1200) => {
    guardUntil = Math.max(guardUntil, Date.now() + ms);
    window.__SQ_EXPANDED_CLOSE_GUARD_UNTIL__ = Math.max(
      Number(window.__SQ_EXPANDED_CLOSE_GUARD_UNTIL__ || 0),
      guardUntil
    );
    window.__SQ_EXPANDED_POINTER_CLOSE_UNTIL__ = Math.max(
      Number(window.__SQ_EXPANDED_POINTER_CLOSE_UNTIL__ || 0),
      guardUntil
    );
    window.__SQ_SUPPRESS_CART_OPEN_UNTIL__ = Math.max(
      Number(window.__SQ_SUPPRESS_CART_OPEN_UNTIL__ || 0),
      guardUntil
    );
  };

  const stopPropagationOnly = (event) => {
    event.stopPropagation?.();
    event.stopImmediatePropagation?.();
  };

  const stopFully = (event) => {
    if (event.cancelable) event.preventDefault();
    stopPropagationOnly(event);
  };

  const controllerFor = (close) => {
    const root = close?.closest(ROOT) || close?.closest(MODAL)?.closest(ROOT);
    const direct = root?.__lcsFavoritesPage || root?.__lcsExpandedController || root?.__sqExpandedController;
    if (direct?.closeExpanded) return direct;
    if (window.SQUniversalExpandedCard?.closeExpanded) return window.SQUniversalExpandedCard;
    for (const host of document.querySelectorAll(ROOT)) {
      const controller = host.__lcsFavoritesPage || host.__lcsExpandedController || host.__sqExpandedController;
      if (controller?.closeExpanded) return controller;
    }
    return null;
  };

  const fallbackClose = (close) => {
    const modal = close?.closest(MODAL);
    const root = modal?.closest(ROOT);
    if (modal instanceof HTMLElement) {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      modal.classList.remove('is-ready', 'has-expanded-options');
    }
    root?.classList.remove('lcs-expanded-active');
    try { window.LCSExpandedModalLock?.unlock?.(); } catch (_) {}
    document.documentElement.classList.remove('lcs-expanded-solid-lock');
    document.body.classList.remove('lcs-expanded-solid-lock');
    document.documentElement.style.removeProperty('--lcs-modal-scroll-y');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.inset = '';
    document.body.style.top = '';
    document.body.style.width = '';
  };

  const finishClose = (close) => {
    const controller = controllerFor(close);
    if (controller?.closeExpanded) {
      try { controller.closeExpanded(); }
      catch (_) { fallbackClose(close); }
    } else {
      fallbackClose(close);
    }
    try { window.SQUniversalBagCloseout?.closeout?.(); } catch (_) {}
  };

  // Critical: do NOT remove the expanded card on pointerdown. If it disappears
  // before pointerup/click, the browser can retarget the gesture to the header
  // cart underneath. Keep the X present for the whole gesture, then close on click.
  window.addEventListener('pointerdown', (event) => {
    if (!closeTarget(event)) return;
    arm();
    stopPropagationOnly(event);
  }, { capture: true, passive: true });

  window.addEventListener('pointerup', (event) => {
    if (!closeTarget(event)) return;
    arm();
    stopPropagationOnly(event);
  }, { capture: true, passive: true });

  window.addEventListener('click', (event) => {
    const close = closeTarget(event);
    if (close) {
      arm();
      stopFully(event);
      finishClose(close);
      return;
    }

    if (Date.now() >= guardUntil) return;
    const target = event.target instanceof Element ? event.target : null;
    if (target?.closest(CART_OPENERS)) stopFully(event);
  }, { capture: true, passive: false });

  ['mousedown','mouseup','touchend'].forEach((name) => {
    window.addEventListener(name, (event) => {
      if (Date.now() >= guardUntil) return;
      const target = event.target instanceof Element ? event.target : null;
      if (target?.closest(CART_OPENERS)) stopFully(event);
    }, { capture: true, passive: false });
  });

  const blockHandoff = (event) => {
    if (Date.now() < guardUntil) stopFully(event);
  };
  document.addEventListener('sq:cart:handoff', blockHandoff, true);
  window.addEventListener('sq:cart:handoff', blockHandoff, true);
})();
